var TEMPLATE_URL = require('./ike.sidebar.html');
angular.module('ikeweb.layout').directive('ikeSidebar',
    function() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: TEMPLATE_URL,
            scope: {
                sidebarTitle: '@'
            }
        };
    }
);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/layout/sidebar/ike.sidebar.directive.js
// module id = 465
// module chunks = 0